import React from 'react';

import IntroductionAddIcon from '@atlaskit/icon-lab/core/text-introduction-add';

export const InsertAtTopIcon = () => <IntroductionAddIcon label="" spacing="spacious" />;
